export const IMAGE_LARGE_CONSUMER_ID = "4454d6cd-d84a-4867-a1b6-3e826a4e8d58";
export const COMPETITION_RUN_CONSUMER_ID =
    "18ebd081-6d3a-4dca-8f58-6e80bf34c830";
